import React from 'react';
import './Courses.css';
import hcaThumb from '../../assets/images/hca-thumb.jpg';
import ceThumb from '../../assets/images/CE-thumb.jpg';
import stThumb from '../../assets/images/ST-thumb.jpg';
import orientation from '../../assets/images/orientation_and_safety_edited.jpg';
import ndThumb from '../../assets/images/ND-thumb.jpg';
import aeThumb from '../../assets/images/AE-thumb.jpg';
import hivThumb from '../../assets/images/HIV-thumb.jpg';

const Courses = () => {
  const courses = [
    {
      id: 1,
      title: "HOME CARE AIDE",
      image: hcaThumb,
      description: "Comprehensive training for home care aides covering all essential skills.",
      hours: "75 hours",
      link: "/courses/home-care-aide"
    },
    {
      id: 2,
      title: "CONTINUING EDUCATION",
      image: ceThumb,
      description: "Advanced courses for healthcare professionals to maintain their credentials.",
      hours: "Varies",
      link: "/courses/continuing-education"
    },
    {
      id: 3,
      title: "SPECIALTY TRAINING",
      image: stThumb,
      description: "Specialized training programs for specific healthcare needs.",
      hours: "Varies",
      link: "/courses/specialty-training"
    },
    {
      id: 4,
      title: "ORIENTATION AND SAFETY",
      image: orientation,
      description: "Essential orientation and safety procedures for healthcare workers.",
      hours: "8 hours",
      link: "/courses/orientation-safety"
    },
    {
      id: 5,
      title: "NURSE DELEGATION",
      image: ndThumb,
      description: "Training for nurses on delegation tasks to nursing assistants.",
      hours: "6 hours",
      link: "/courses/nurse-delegation"
    },
    {
      id: 6,
      title: "ADULT EDUCATION",
      image: aeThumb,
      description: "Educational programs tailored for adult learners in healthcare.",
      hours: "Varies",
      link: "/courses/adult-education"
    },
    {
      id: 7,
      title: "HIV/AIDS TRAINING",
      image: hivThumb,
      description: "Specialized training on HIV/AIDS care and prevention.",
      hours: "7 hours",
      link: "/courses/hiv-aids"
    },
    {
      id: 8,
      title: "CNA BRIDGE PROGRAM",
      image: hcaThumb,
      description: "Transition from HCA to CNA with our comprehensive bridge program.",
      hours: "75 hours",
      link: "/courses/cna-bridge"
    }
  ];

  return (
    <section className="courses-section">
      <div className="container">
        <h2 className="section-title">Our Courses</h2>
        <div className="courses-grid">
          {courses.map((course) => (
            <div className="course-card" key={course.id}>
              <div className="course-image">
                <img src={course.image} alt={course.title} />
              </div>
              <div className="course-content">
                <h3>{course.title}</h3>
                <p>{course.description}</p>
                <div className="course-meta">
                  <span className="hours">{course.hours}</span>
                  <a href={course.link} className="btn">Learn More</a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Courses;